$(document).on('click', '.dropdown-menu[data-persistent]', function(e) {
  return e.stopPropagation();
});
